<template>
  <div class="users-site-notifications d-flex flex-column pt-3">
    <div v-for="notification in notifications" :key="notification.id"
         class="notification pr-5 pl-5 pt-2 pb-2 mb-2 elevation-6 align-self-center d-flex flex-row align-baseline"
         :class="{info: notification.type === 'INFO', warning: notification.type === 'WARNING'}">
      <div class="message">{{ notification.message }}</div>
      <div class="ml-2">
        <v-btn icon
               @click="dismiss(notification.id)"
               :title="$t('actions.close')">
          <v-icon :color="getCloseButtonColor(notification)">mdi-close</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>
<style>

.users-site-notifications {
  width: 100%;
  z-index: 1000;
  position: fixed;
  top: 0;

}

.users-site-notifications .notification {
  max-width: 40em;
  border-radius: 4px;

}

.users-site-notifications .notification.warning {
  color: black;
}

.users-site-notifications .notification.info {
  color: white;
}

.users-site-notifications .notification .message {
  display: inline-block;
  white-space: pre-line;
}

</style>


<script>
import SiteNotificationsService from '@/services/SiteNotificationsService';

export default {
  name: 'SiteNotificationViewer',
  computed: {
    notifications() {
      return this.$store.state.siteNotificationsViewerState.notifications;
    },
  },
  data() {
    return {
      timer: null,
    };
  },
  methods: {
    dismiss(notificationId) {
      SiteNotificationsService.dismiss(notificationId).then(() => {
        this.$store.dispatch('siteNotificationsViewerState/update');
      });
    },

    getCloseButtonColor(notification) {
      if (notification.type === 'INFO') {
        return 'white';
      }
      return 'black';
    },

    doAutoUpdate() {
      this.$store.dispatch('siteNotificationsViewerState/update');
    },
  },


  created() {
    this.$store.dispatch('siteNotificationsViewerState/init');
    this.timer = setInterval(this.doAutoUpdate, 1000 * 60 * 60);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
